import { render, staticRenderFns } from "./TplItemLogo.vue?vue&type=template&id=9107884e&"
import script from "./TplItemLogo.vue?vue&type=script&lang=js&"
export * from "./TplItemLogo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports